import {
  Container,
  Flex,
  Box,
  Heading,
  Text,
  IconButton,
  Button,
  VStack,
  HStack,
  Wrap,
  WrapItem,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Textarea,
} from "@chakra-ui/react";
import {
  MdPhone,
  MdEmail,
  MdLocationOn,
  MdFacebook,
  MdOutlineEmail,
} from "react-icons/md";
import { BsGithub, BsPerson, BsLinkedin } from "react-icons/bs";

export default function contact() {
  return (
    <div id="contact">
    <Container
      // bg="white"
      color="white"
    padding={'10px'}
      maxW="92%"
      mt={0}
      centerContent
      overflow="hidden"
      id="contact"
    >
      <Flex>
        <Box
          bg="white"
          color="black"
          borderRadius="lg"
          m={{ sm: 10, md: 16, lg: 10 }}
          p={{ sm: 10, md: 5, lg: 16 }}
        >
          <Box p={10}>
            <Heading textAlign={'center'}>CONTACT</Heading>
            <Text mt={{ sm: 3, md: 3, lg: 5 }} textAlign={'center'} color="gray.500">
              Please fill up the form below to contact in future
            </Text>
            <Wrap spacing={{ base: 20, sm: 3, md: 5, lg: 20 }}>
              {/* <WrapItem> */}
                <Box>
                  <Box py={{ base: 5, sm: 5, md: 8, lg: 10 }}>
                    <VStack pl={0} spacing={3} alignItems="flex-start">
                      <Button
                        size="md"
                        height="48px"
                        width="200px"
                        variant="ghost"
                        color="black"
                        // border='1px solid red'                     
                        _hover={{ border: "2px solid #1C6FEB" }}
                        leftIcon={<MdPhone color="black" size="20px" />}
                        id="contact-phone"
                      >
                        +91-8103428030
                      </Button>
                      <Button
                        size="md"
                        height="48px"
                        width="300px"
                        variant="ghost"
                        color="black"
                        id="contact-email"
                        _hover={{ border: "2px solid #1C6FEB" }}
                        leftIcon={<MdEmail color="black" size="20px" />}
                      >
                        charchitkhandelwal45@gmail.com
                      </Button>
                      <Button
                        size="md"
                        height="48px"
                        width="220px"
                        variant="ghost"
                        color="black"
                        _hover={{ border: "2px solid #1C6FEB" }}
                        leftIcon={<MdLocationOn color="black" size="20px" />}
                      >
                        Indore, MadhyaPradesh
                      </Button>
                    </VStack>
                  </Box>
                  <HStack
                    mt={{ lg: 10, md: 10 }}
                    spacing={5}
                    px={5}
                    alignItems="flex-start"
                  >
                    <a href="https://github.com/charchit07" target="_blank">
                      {" "}
                      <IconButton
                        aria-label="github"
                        size="lg"
                        isRound={true}
                        icon={<BsGithub size="28px" />}
                        id="contact-github"
                      />
                    </a>
                    <a
                      href="https://www.linkedin.com/in/charchitkhandelwal/"
                      target="_blank"
                    >
                      {" "}
                      <IconButton
                        aria-label="linked"
                        size="lg"
                        isRound={true}
                        icon={<BsLinkedin size="28px" />}
                        id="contact-linkedin"
                      />
                    </a>
                  </HStack>
                </Box>
              {/* </WrapItem> */}
              <WrapItem>
                <Box bg="white" borderRadius="lg">
                  <Box m={8} color="#0B0E3F">
                    <VStack spacing={5}>
                      <FormControl id="name">
                        <FormLabel>Your Name</FormLabel>
                        <InputGroup borderColor="#E0E1E7">
                          <InputLeftElement
                            pointerEvents="none"
                            children={<BsPerson color="gray.800" />}
                          />
                          <Input type="text" size="md" />
                        </InputGroup>
                      </FormControl>
                      <FormControl id="name">
                        <FormLabel>Mail</FormLabel>
                        <InputGroup borderColor="#E0E1E7">
                          <InputLeftElement
                            pointerEvents="none"
                            children={<MdOutlineEmail color="gray.800" />}
                          />
                          <Input type="text" size="md" />
                        </InputGroup>
                      </FormControl>
                      <FormControl id="name">
                        <FormLabel>Message</FormLabel>
                        <Textarea
                          borderColor="gray.300"
                          _hover={{
                            borderRadius: "gray.300",
                          }}
                          placeholder="message"
                        />
                      </FormControl>
                      <FormControl id="name" float="right">
                        <Button>Send Message</Button>
                      </FormControl>
                    </VStack>
                  </Box>
                </Box>
              </WrapItem>
            </Wrap>
          </Box>
        </Box>
      </Flex>
    </Container>
    </div>
  );
}
